import React from "react";
import "./banner.scss";

const Banner = () => {
  return (
    <>
      <div className="outter_layer_new">
        <section className="banner-main">
          <img
            src="\assets\homepage\banner\banner-shadow.png"
            alt="img"
            className="img-fluid banner-shadow"
          />
          <video
            className="main-banner-video"
            muted="muted"
            playsinline="playsinline"
            autoPlay
            loop
            width="100%"
            id="myVideo"
          >
            <source src="\assets\bannervideo.mp4" type="video/mp4" />
          </video>
          <div className="custom-container">
            <div className="inner-banner">
              <div className="left-side">
                <div>
                  <h2>The Ecosystem Engine</h2>
                  <p>
                    Explore the next generation of decentralized applications
                    built on our core protocol. From high-frequency trading to
                    provably fair gaming, this is where the market’s most
                    innovative builders deploy their vision.
                  </p>
                 
                </div>
              </div>
      
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Banner;
